import { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Modal from 'components/Modal'
import { SUPPORT_PHONE_ALERT_KEY } from 'variables'

const TEMPORARY_PHONE_NUMBER = '01 82 88 82 38'

const SupportPhoneAlert = () => {
  const { t } = useTranslation()
  //const [open, setOpen] = useState(() => sessionStorage.getItem(SUPPORT_PHONE_ALERT_KEY) === 'true')
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    sessionStorage.removeItem(SUPPORT_PHONE_ALERT_KEY)
    setOpen(false)
  }

  if (!open) return null

  return (
    <Modal
      title={t('auth.support_phone_alert.title', 'Information importante')}
      onClose={handleClose}
      minWidth="420px"
      maxWidth="480px"
    >
      <Typography
        sx={{
          fontSize: 14,
          color: '#464646',
          lineHeight: 1.5,
          '& p': { m: 0 },
          '& p + p': { mt: 1.5 },
          '& a': { color: '#587F31', fontWeight: 600 }
        }}
        dangerouslySetInnerHTML={{ __html: t('auth.support_phone_alert.body') }}
      />
      <Typography sx={{ fontSize: 14, color: '#464646', lineHeight: 1.5 }}>
        {t('auth.support_phone_alert.phone_intro')}
      </Typography>
      <Box
        component="a"
        aria-label={TEMPORARY_PHONE_NUMBER}
        sx={{
          display: 'block',
          textAlign: 'center',
          textDecoration: 'none',
          backgroundColor: '#E6F0D7',
          border: '1px solid #C5D9A8',
          borderRadius: '12px',
          px: 2,
          py: 1.5,
          color: '#587F31',
          fontSize: 18,
          fontWeight: 600,
          letterSpacing: '0.02em'
        }}
      >
        {TEMPORARY_PHONE_NUMBER}
      </Box>
      <Button
        variant="contained"
        size="small"
        onClick={handleClose}
        sx={{
          mt: 1,
          height: 44,
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 500
        }}
      >
        {t('auth.support_phone_alert.confirm')}
      </Button>
    </Modal>
  )
}

export default SupportPhoneAlert
